export default "__VITE_ASSET__Bcd3zPM5__"